import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from '@domain-group/fe-co-date-picker';
import Select from '@domain-group/fe-co-select';
import { startOfToday, addDays, isAfter } from 'date-fns';
import * as styles from '../../styles/homepass-booking/homepass-booking-structure';
import DateSelector from './date-selector';
import { LAST_INSPECTION_TIME } from '../constant';

/**
 * if enabled, returns the min start date for the calendar
 * The last inspection time is 20:00 at local time, if current time
 * later than LAST_INSPECTION_TIME: 20:00, the min date should start from the
 * following day
 * @param {Boolean} enableMinDateTime
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
var getMinDateTime = enableMinDateTime => {
  if (enableMinDateTime) {
    var currentDateTime = new Date();
    var followingDateTime = addDays(currentDateTime, 1);
    var lastInspectionTimeToday = startOfToday().setHours(LAST_INSPECTION_TIME);
    return isAfter(currentDateTime, lastInspectionTimeToday) ? followingDateTime : currentDateTime;
  }
  return false;
};
var CustomDateInputs = props => ___EmotionJSX("div", null, ___EmotionJSX("div", {
  css: styles.modalRow
}, ___EmotionJSX("div", {
  css: styles.modalColumn
}, ___EmotionJSX("div", {
  css: styles.modalDateLabel
}, "Preferred date")), ___EmotionJSX("div", {
  css: styles.modalColumn
}, ___EmotionJSX("div", {
  css: styles.modalTimeLabel
}, "Preferred time"))), ___EmotionJSX("div", {
  css: styles.modalRow
}, ___EmotionJSX("div", {
  css: styles.modalColumn
}, ___EmotionJSX(DatePicker, {
  css: styles.datePicker,
  theme: props.theme,
  selected: props.availableCalendarEventsSelectedDate,
  onChange: props.onDateChange,
  trigger: ___EmotionJSX(DateSelector, null),
  minDate: getMinDateTime(props.isV2APIs),
  includeDates: props.isV2APIs ? false : props.availableCalendarEvents.map(_ref => {
    var startDate = _ref.startDate;
    return new Date(startDate);
  })
})), ___EmotionJSX("div", {
  css: styles.modalColumn
}, ___EmotionJSX(Select, {
  options: props.availableCalendarEventsTimeOptions,
  value: props.availableCalendarEventsIndex,
  onChange: props.onTimeChange,
  labelHidden: true,
  label: "Select another inspection time"
}))));
CustomDateInputs.propTypes = {
  availableCalendarEvents: PropTypes.arrayOf(PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired
  }).isRequired).isRequired,
  availableCalendarEventsTimeOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  availableCalendarEventsSelectedDate: PropTypes.instanceOf(Date).isRequired,
  availableCalendarEventsIndex: PropTypes.string.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  isV2APIs: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired
};
export default CustomDateInputs;